<template lang="pug">
	b-form-group
		b-input-group
			b-input-group-prepend
				b-input-group-text
					i.fa.fa-search
			b-form-input(v-model="page.participant.filterDelivery.name" @input="input")
			b-button.ml-2(variant="danger" @click="reset") очистить
</template>
<script>
	import { mapState } from "vuex";


	export default {
		name: 'deliveryFilter',
		data: () => ({

		}),
		computed: {
			...mapState(['page'])
		},
		methods:{
			input(val){ this.$store.dispatch('setDeliveryFilter',val) },
			reset(){ this.$store.dispatch('setDeliveryFilter','') }
		},
	}
</script>
